import { Component, input } from '@angular/core';

import { CustomFieldsModel } from '../../../../../../reducers/orm/custom-fields/custom-fields.model';
import {
  TimesheetColumns,
  TimesheetCustomFieldsColumns,
} from '../../../../../../reducers/page-filters/page-filters.model';

/**
 * The centre columns of a row that shows nothing under them — an employee with no
 * registrations, or the grand totals.
 *
 * Such a row still has to declare every column: the row is what the pinned columns
 * measure their edge against, so a row that stops at the fold lets its right-hand
 * column drift inwards as the grid scrolls, and a row outside the scroll container
 * has nothing to scroll at all.
 */
@Component({
  standalone: false,
  selector: 'timesheet-day-blank-columns',
  templateUrl: './timesheet-day-blank-columns.component.html',
  // The cells belong to the row's flex line, not to a box of their own.
  host: {
    class: 'contents',
  },
})
export class TimesheetDayBlankColumnsComponent {
  cols = input<TimesheetColumns>();

  customFields = input<CustomFieldsModel[]>([]);
  customFieldCols = input<TimesheetCustomFieldsColumns>();
}
